export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.png" alt="About Me" />
      </div>
      <div className="about--section--box">
        <div className="about--section--content">
          <h1 className="skills--section--heading">ABOUT US</h1>
          <p className="about--section--description">
            Welcome to West Coast Auto Detailing, where your vehicle’s
            appearance is our passion. Founded in 2018, our company has rapidly
            grown to become a trusted name in the automotive care industry,
            serving car enthusiasts and everyday drivers alike.
          </p>
          <p className="about--section--description">
            At West Coast Auto Detailing, we specialize in paint correction and
            ceramic coating services. Our mission is to bring out the best in
            your vehicle, making it look and feel like new again. Whether you
            need a comprehensive interior and exterior detailing, restoration of
            your vehicle’s paint to its original glory, or a durable ceramic
            coating for long-lasting protection, we’ve got you covered.
          </p>
          <p className="about--section--description">
            Our team of skilled professionals is accredited for one of the
            strongest ceramic coatings on the market, Nasiol ceramic coating and
            we are also a certified applicator for System X ceramic coating.
            Trust us to keep your vehicle in pristine condition, so you can
            drive with confidence and pride.
          </p>
        </div>
      </div>
    </section>
  );
}
